<template>
  <span
    class="brand-logo"
    :class="{
      'brand-logo--mark-only': !showName,
      'brand-logo--vecura': variant === 'vecura',
    }"
  >
    <span class="brand-logo__asset" aria-hidden="true"></span>
  </span>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BrandLogo",
  props: {
    showName: {
      type: Boolean,
      default: true,
    },
    variant: {
      type: String,
      default: "default",
      validator(value: string): boolean {
        return ["default", "vecura"].includes(value);
      },
    },
  },
});
</script>

<style scoped>
.brand-logo {
  display: inline-flex;
  align-items: center;
  color: inherit;
}

.brand-logo__asset {
  display: block;
  width: clamp(250px, 27vw, 318px);
  aspect-ratio: 1198 / 159;
  background-image: url("../assets/rothdeutsch-logo.png");
  background-position: left center;
  background-repeat: no-repeat;
  background-size: contain;
}

.brand-logo--vecura .brand-logo__asset {
  background-image: url("../assets/rothdeutsch-logo-vecura.png");
}

.brand-logo--mark-only .brand-logo__asset {
  width: 62px;
  aspect-ratio: 246 / 189;
  background-image: url("../assets/rothdeutsch-mark.png");
}

.brand-logo--mark-only.brand-logo--vecura .brand-logo__asset {
  background-image: url("../assets/rothdeutsch-mark-vecura.png");
}

@media (max-width: 760px) {
  .brand-logo__asset {
    width: 58px;
    aspect-ratio: 246 / 189;
    background-image: url("../assets/rothdeutsch-mark.png");
  }

  .brand-logo--vecura .brand-logo__asset {
    background-image: url("../assets/rothdeutsch-mark-vecura.png");
  }
}
</style>
